// import React from "react";

// import {
//   Box,
//   Typography,
//   IconButton,
//   DialogTitle,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";

// const ModalHeader = ({ icon, title, subtitle, onClose }) => (
//   <DialogTitle
//   sx={{
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "flex-start",
//     borderBottom: "1px solid rgba(255,255,255,0.08)",
//     pb: 2,
//     pt: 3,
//     px: 3,
//     flexShrink: 0,        // ← ADD THIS
//     background: "#1a1a1a", // ← inherit mat karo, hardcode karo
//     zIndex: 1,
    
//   }}
// >
//     <Box display="flex" alignItems="flex-start" gap={1.5}>
//       {icon && (
//         <Typography fontSize={22} lineHeight={1}>
//           {icon}
//         </Typography>
//       )}
//       <Box>
//         <Typography variant="h6" fontWeight={600} sx={{ lineHeight: 1.3 }}>
//           {title}
//         </Typography>
//         {subtitle && (
//           <Typography
//             variant="body2"
//             color="text.secondary"
//             sx={{ mt: 0.5, fontSize: "13px" }}
//           >
//             {subtitle}
//           </Typography>
//         )}
//       </Box>
//     </Box>
//     <IconButton
//       onClick={onClose}
//       size="small"
//       sx={{
//         color: "text.secondary",
//         "&:hover": { color: "#3b82f6", background: "rgba(59,130,246,0.1)" },
//       }}
//     >
//       <CloseIcon fontSize="small" />
//     </IconButton>
//   </DialogTitle>
// );

// export default ModalHeader;


import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ModalHeader = ({ icon, title, subtitle, onClose }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      borderBottom: "1px solid rgba(255,255,255,0.08)",
      pb: 2,
      pt: 3,
      px: 3,
      flexShrink: 0,
      background: "#1a1a1a",
    }}
  >
    <Box display="flex" alignItems="flex-start" gap={1.5}>
      {icon && (
        <Typography fontSize={22} lineHeight={1}>{icon}</Typography>
      )}
      <Box>
        <Typography variant="h6" fontWeight={600} sx={{ lineHeight: 1.3 }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, fontSize: "13px" }}>
            {subtitle}
          </Typography>
        )}
      </Box>
    </Box>
    <IconButton onClick={onClose} size="small" sx={{ color: "text.secondary", "&:hover": { color: "#3b82f6" } }}>
      <CloseIcon fontSize="small" />
    </IconButton>
  </Box>
);

export default ModalHeader;